
























































import { Vue, Component } from 'vue-property-decorator'
import horses from '../data/horses.json'
import { HorseDescription } from '../types'

const AppProps = Vue.extend({
  props: {}
})

@Component({})
export default class About extends AppProps {
  firstYear = 2010
  chosenYear: number = this.currentYear
  campHestYears: number[] = Array(this.currentYear - this.firstYear + 1).fill(1).map((x, y) => (x + y + this.firstYear - 1))
  den_heste_liste: HorseDescription[] = horses;

  getImage (imageName: string) {
    return !imageName ? require('../assets/heste_mates/pony_free.png') : require('../assets/heste_mates/' + imageName)
  }

  get horsesInYear () {
    return this.den_heste_liste.filter(horse => horse.yearsAtRoskilde.includes(this.chosenYear.toString()))
  }

  get currentYear () {
    const date = new Date()
    return date.getFullYear()
  }
}

